<template>
  <a-modal
    v-bind:open="showModal"
    width="600px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :body-style="{ borderRadius: '50px' }"
    :mask-style="{ backdropFilter: 'blur(2px)' }"
    :keyboard="false"
    footer
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
  >
    <template #title>
      <div class="modal-title">STM 표면처리 안내</div>
    </template>
    <div id="stm-modal" class="dent-modal-common">
      <div class="modal-content">
        <div class="modal-body">
          <div class="gif-wrap single">
            <div class="gif-container">
              <img :src="stmImageUrl" />
            </div>
          </div>
          <div class="content-wrap">
            <div class="img-area medal">
              <img class="w-36" src="@/assets/img/medal.webp" />
            </div>
            <div class="content-section">
              <div class="content-title">
                {{ brandName }} STM 표면처리 인증서
              </div>
              <div class="content-content">
                {{ brandName }}의 STM(Surface Modification Technology) 기술을
                통해 표면처리된 지르코니아를 사용하였음을 보증합니다.
              </div>
            </div>
          </div>
          <div class="content-wrap">
            <div class="img-area shine">
              <img class="w-28" src="@/assets/img/shine.svg" />
            </div>
            <div class="content-section">
              <div class="content-title">STM 지르코니아 표면처리 기술</div>
              <div class="content-content">
                STM 기술은 지르코니아 표면을 특수 처리하여 심미성과 내구성을
                향상시키는 {{ brandName }}의 고유 기술입니다. 자연치아와 유사한
                투명도와 색상을 구현하며, 장기간 안정적인 사용이 가능합니다.
              </div>
            </div>
          </div>
          <div class="content-wrap">
            <div class="img-area graph">
              <img class="w-28" src="@/assets/img/graph_icon.webp" />
            </div>
            <div class="content-section">
              <div class="content-title" style="margin-bottom: 10px">
                표면처리 효과
              </div>
              <div class="content-content">
                <div class="content-row">
                  <div class="check-box">
                    <i class="fa-solid fa-check" />
                  </div>
                  자연치아와 유사한 심미성 구현
                </div>
                <div class="content-row">
                  <div class="check-box">
                    <i class="fa-solid fa-check" />
                  </div>
                  우수한 내구성 및 강도 확보
                </div>
                <div class="content-row">
                  <div class="check-box">
                    <i class="fa-solid fa-check" />
                  </div>
                  변색 및 플라그 부착 최소화
                </div>
                <div class="content-description">
                  <div class="content-desc-row">
                    *{{ brandName }} STM 기술은 의료기기 허가를 받은 기술입니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["closeModal"],
  computed: {
    stmImageUrl() {
      // zh locale인 경우 중국어 이미지 사용
      if (this.$i18n.locale === "zh") {
        return "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card/DENT/stm_chinese.png";
      } else {
        return require("@/assets/video/dentalmax_stm.gif");
      }
    },
    brandName() {
      // zh locale인 경우 DENTALMAX로 표시
      return this.$i18n.locale === "zh" ? "DENTALMAX" : "덴탈맥스";
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeModal", "stmModal", false);
    },
  },
};
</script>
<style lang="scss" scoped>
$Gray-5: #f7f8f8;
$Gray-10: #f1f2f3;
$Gray-20: #e8ebed;
$Gray-30: #dde0e4;
$Gray-50: #acb2b9;
$Gray-60: #8d939a;
$Gray-70: #6e747c;
$Gray-80: #4b5158;
$Gray-90: #2f3337;
$Gray-100: #17191c;
$Blue: #278aec;
$Yellow: #ffe414;

// 아이콘 폴백 스타일 추가
.icon-fallback {
  width: 48px;
  height: 48px;
  background: #fffbf0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 24px;
    color: $Yellow;
  }
}

.modal-title {
  font-family: "SuitBold";
  font-size: 18px;
  color: $Gray-90;
}

.dent-modal-common {
  font-size: 14px;
  line-height: 1.5714285714285714;
  word-wrap: break-word;
  .modal-content {
    padding: 0;
    border: 0;

    .modal-body {
      .gif-wrap.single {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .gif-container {
          width: 100%;
          max-width: 400px;

          img {
            width: 100%;
            height: auto;
            border-radius: 12px;
          }

          .gif-fallback {
            width: 100%;
            height: 200px;
            background: $Gray-10;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 12px;
            border: 2px dashed $Gray-30;

            i {
              font-size: 48px;
              color: $Yellow;
            }

            span {
              color: $Gray-70;
              font-size: 14px;
              font-weight: 500;
            }
          }
        }
      }

      .content-wrap {
        display: flex;
        gap: 16px;
        align-items: flex-start;

        .img-area {
          flex: 0 0 48px;

          img {
            width: 48px;
            height: 48px;
            object-fit: contain;
            font-size: 14px;
            line-height: 1.5714285714285714;
            word-wrap: break-word;
          }
          .w-36 {
            width: 36px;
          }
          .w-28 {
            width: 28px;
          }

          &.medal img {
            filter: brightness(1.2);
          }
        }

        .content-section {
          flex: 1;

          .content-title {
            font-size: 16px;
            font-weight: 600;
            color: $Gray-90;
            margin-bottom: 8px;
          }

          .content-content {
            line-height: 1.5714285714285714;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "./css/issue-modals.scss";
.ant-modal .ant-modal-body .content-row {
  font-size: 16px;
  line-height: 1.5714285714285714;
  word-wrap: break-word;
}
</style>
